class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = this.closest(".not-pu-section");
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.hideForSubscribers = this.dataset.hideForSubscribers === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.cookieDays = Number(this.dataset.cookieDays) || 7;
    this.storageKey = this.dataset.storageKey || "hideNotificationPopup";
    this.cookie = document.cookie
      .split(";")
      .some((item) => item.trim().startsWith(`${this.storageKey}=true`));
    this.designMode = this.dataset.designMode === "true";

    if (
      !this.designMode &&
      ((this.hideForSubscribers && this.hasSubscription) || this.cookie || !this.isWithinDisplayPeriod())
    )
      return;

    setTimeout(() => {
      this.popup.classList.remove("hidden");
      this.popup.classList.add("wt-popup-fade-in");
    }, this.delay * 1000);

    this.closeBtn?.addEventListener("click", (event) => {
      event.preventDefault();
      this.popup.classList.add("hidden");
      if (!this.designMode) this.setCookie(this.storageKey, "true", this.cookieDays);
    });
  }

  isWithinDisplayPeriod() {
    const now = new Date();
    const start = this.parseDate(this.dataset.startDate, false);
    const end = this.parseDate(this.dataset.endDate, true);

    return (!start || now >= start) && (!end || now <= end);
  }

  parseDate(value, endOfDay) {
    if (!value) return null;

    const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
    const date = new Date(dateOnly ? `${value}T${endOfDay ? "23:59:59.999" : "00:00:00"}` : value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
}

customElements.define("notification-popup", NotificationPopup);
